/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-restricted-globals */
import moment from 'moment';

export const formatEpochDate = (timeEpoch, format = 'MMM DD YYYY HH:mm:ss') => {
    if (!timeEpoch) return '';

    const date = moment(timeEpoch, 'x');
    if (date.isValid() && timeEpoch !== '0') return date.format(format);

    return '';
};

export function getTransactionType(tx) {
    const { type } = tx;
    switch (type) {
        case 's':
            return 'Send';
        case 'r':
            return 'Received';
        case 'd':
            return 'Deposit';
        case 'o':
            return 'Order';
        case 'w':
            return 'Withdrawal';
        case 'e':
            if (tx.IsAdjustment) {
                return 'Adjustment';
            }

            return 'Redeem';
        default:
            return type;
    }
}

export const validateWalletAddress = (value) => {
    if (!value) {
        return 'Required';
    }

    if (!/^0x([0-9]|[A-F]|[a-f])+$/.test(value)) {
        return 'Wallet address contains invalid characters';
    }

    if (value.length !== 42) {
        return 'Wallet address is an invalid length';
    }

    return null;
};